import { render, staticRenderFns } from "./ReindexSettings.vue?vue&type=template&id=9e7480c4&scoped=true"
import script from "./ReindexSettings.vue?vue&type=script&lang=js"
export * from "./ReindexSettings.vue?vue&type=script&lang=js"
import style0 from "./ReindexSettings.vue?vue&type=style&index=0&id=9e7480c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e7480c4",
  null
  
)

export default component.exports